import React from "react";
import { siteConfig } from "../../config/siteConfig";
import Eyebrow from "../ui/Eyebrow";
import Reveal from "../ui/Reveal";
import Icon from "../ui/Icon";

// Coche succès — sémantique emerald INTACTE (bonne réponse / inclus).
const Check = () => (
  <Icon name="check" className="w-5 h-5 text-emerald-600 flex-shrink-0" />
);

// Croix erreur — sémantique red/rose INTACTE (non inclus / carence).
const Cross = () => (
  <svg
    className="w-5 h-5 text-rose-400 flex-shrink-0"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 18L18 6M6 6l12 12" />
  </svg>
);

// Tabla comparativa "con la plataforma vs por tu cuenta". Se oculta sola si la
// niche no define siteConfig.comparison.rows.
const Comparison = () => {
  const data = siteConfig.comparison;
  if (!data || !data.rows || data.rows.length === 0) return null;

  return (
    <section id="comparativa" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          {data.eyebrow ? (
            <Reveal className="inline-flex justify-center">
              <Eyebrow>{data.eyebrow}</Eyebrow>
            </Reveal>
          ) : null}
          <Reveal as="h2" index={1} className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mt-4 mb-6">
            {data.title}
          </Reveal>
          {data.subtitle ? (
            <Reveal as="p" index={2} className="text-lg md:text-xl text-slate-600 leading-snug">
              {data.subtitle}
            </Reveal>
          ) : null}
        </div>

        {/* Tableau hairline sur blanc .elev-1 — filets neutres slate-200/70. */}
        <div className="overflow-hidden rounded-2xl bg-white ring-1 ring-slate-200/70 elev-1">
          <div className="grid grid-cols-[1.4fr_1fr_1fr] tabular-nums">
            {/* Encabezado */}
            <div className="bg-white p-3 sm:p-5" />
            <div className="bg-teal-50/70 p-3 sm:p-5 text-center text-teal-800 text-xs sm:text-base font-bold border-l border-slate-200/70">
              {data.withLabel || "Palvelun kanssa"}
            </div>
            <div className="bg-white p-3 sm:p-5 text-center text-slate-500 text-xs sm:text-base font-semibold border-l border-slate-200/70">
              {data.withoutLabel || "Omin päin"}
            </div>

            {/* Filas — reveal staggeré ligne par ligne. Chaque cellule reste
                un enfant direct de la grille (Reveal rend une <div>), les 3
                cellules d'une même ligne partagent le même index de stagger. */}
            {data.rows.map((row, i) => {
              const hasWithoutText = typeof row.without === "string" && row.without.length > 0;
              const hasWithText = typeof row.withUs === "string" && row.withUs.length > 0;
              return (
                <React.Fragment key={i}>
                  <Reveal index={i} className="p-3 sm:p-5 text-xs sm:text-sm font-semibold text-slate-700 border-t border-slate-200/70">
                    {row.label}
                  </Reveal>
                  <Reveal index={i} className="p-3 sm:p-5 flex flex-col sm:flex-row items-center justify-center gap-1.5 text-center text-xs sm:text-sm font-semibold text-slate-800 bg-teal-50/40 border-t border-l border-slate-200/70">
                    <Check />
                    {hasWithText ? <span>{row.withUs}</span> : null}
                  </Reveal>
                  <Reveal index={i} className="p-3 sm:p-5 flex flex-col sm:flex-row items-center justify-center gap-1.5 text-center text-xs sm:text-sm text-slate-400 border-t border-l border-slate-200/70">
                    <Cross />
                    {hasWithoutText ? <span>{row.without}</span> : null}
                  </Reveal>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
